function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "50,10 80,50 50,90 20,50",
    style: {
      fill: "white",
      stroke: "#8A2BE2",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,20 70,50 50,80 30,50",
    style: {
      fill: "white",
      stroke: "#8A2BE2",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.f7146ca79004d3721eb09674d0723f76.svg";
export { ForwardRef as ReactComponent };